export var _toLazyIndexed = function _toLazyIndexed(fn) {
  fn.indexed = true;
  return fn;
};